import type { RouteHandle } from "#types/RouteHandle.ts";

export const Routes = {
    Home: () => "/",
    Conversation: (conversationId: string) => `/conversations/${conversationId}`,
    Personalization: () => "/personalization",
    SmartReports: () => "/smart-reports",
    SmartReportsEdit: () => "/smart-reports/edit"
} as const;

export const RouteHandles = {
    Home: {
        trackingName: "Home"
    } satisfies RouteHandle,
    Conversation: {
        trackingName: "Conversation"
    } satisfies RouteHandle,
    Personalization: {
        trackingName: "Personalization"
    } satisfies RouteHandle,
    SmartReports: {
        trackingName: "Smart Reports Configurations List"
    } satisfies RouteHandle,
    SmartReportsEdit: {
        trackingName: "Smart Report Configuration Edit"
    } satisfies RouteHandle
} as const;
